export const FIRM_LOGIN_NOT_ALLOWED_CODE = "FIRM_LOGIN_NOT_ALLOWED";
export const ACCOUNT_DISABLED_CODE = "ACCOUNT_DISABLED";
export const ACCOUNT_DISABLED_MESSAGE =
  "This account has been disabled. Contact WSG support if you need assistance.";

const DEFAULT_FIRM_LOGIN_MESSAGE =
  "Your firm's membership status does not allow sign-in. Contact WSG support if you need assistance.";

/**
 * Login / 2FA / SSO may return either a plain string body or
 * `{ code, message }` (e.g. FIRM_LOGIN_NOT_ALLOWED).
 */
export function resolveAuthErrorPayload(data: unknown): {
  message: string;
  isFirmLoginNotAllowed: boolean;
  isAccountDisabled: boolean;
} {
  if (data == null) {
    return {
      message: "",
      isFirmLoginNotAllowed: false,
      isAccountDisabled: false,
    };
  }
  if (typeof data === "string") {
    return {
      message: data,
      isFirmLoginNotAllowed: false,
      isAccountDisabled: data.trim() === ACCOUNT_DISABLED_MESSAGE,
    };
  }
  if (typeof data === "object") {
    const body = data as { code?: unknown; message?: unknown; status?: unknown };
    if (body.code === FIRM_LOGIN_NOT_ALLOWED_CODE) {
      return {
        message:
          typeof body.message === "string" && body.message.trim()
            ? body.message
            : DEFAULT_FIRM_LOGIN_MESSAGE,
        isFirmLoginNotAllowed: true,
        isAccountDisabled: false,
      };
    }
    if (body.code === ACCOUNT_DISABLED_CODE) {
      return {
        message:
          typeof body.message === "string" && body.message.trim()
            ? body.message
            : ACCOUNT_DISABLED_MESSAGE,
        isFirmLoginNotAllowed: false,
        isAccountDisabled: true,
      };
    }
    if (typeof body.message === "string" && body.message.trim()) {
      return {
        message: body.message,
        isFirmLoginNotAllowed: false,
        isAccountDisabled: false,
      };
    }
  }
  return {
    message: String(data),
    isFirmLoginNotAllowed: false,
    isAccountDisabled: false,
  };
}
